/**
 * This code was AUTOGENERATED using the codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type Codec,
  type Decoder,
  type Encoder,
} from '@solana/kit';

export enum EquatableOperator {
  Equal,
  NotEqual,
}

export type EquatableOperatorArgs = EquatableOperator;

export function getEquatableOperatorEncoder(): Encoder<EquatableOperatorArgs> {
  return getEnumEncoder(EquatableOperator);
}

export function getEquatableOperatorDecoder(): Decoder<EquatableOperator> {
  return getEnumDecoder(EquatableOperator);
}

export function getEquatableOperatorCodec(): Codec<
  EquatableOperatorArgs,
  EquatableOperator
> {
  return combineCodec(
    getEquatableOperatorEncoder(),
    getEquatableOperatorDecoder()
  );
}
